export default "__VITE_ASSET__k_a0Ocek__"